import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum GiftIconVariant {
  DEFAULT = 'default',
}

export interface IGiftIconProps extends IConDefaultType {
  variant?: GiftIconVariant;
  backgroundColor?: string;
}

function GiftIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = GiftIconVariant.DEFAULT,
  backgroundColor = 'white',
}: IGiftIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === GiftIconVariant.DEFAULT && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" fill={backgroundColor} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.6981 5.33223C8.38853 5.33223 8.09183 5.45504 7.87322 5.67334C7.65465 5.89161 7.53202 6.18744 7.53202 6.49571C7.53202 6.80398 7.65465 7.09981 7.87322 7.31808C8.09183 7.53637 8.38853 7.65918 8.6981 7.65918H11.1056C11.0106 7.40045 10.8855 7.10733 10.7258 6.81734C10.261 5.97352 9.61077 5.33223 8.6981 5.33223ZM4.66667 7.67146H6.49315C6.30158 7.31293 6.19869 6.90965 6.19869 6.49571C6.19869 5.83321 6.46225 5.19803 6.93109 4.72986C7.39989 4.26173 8.03552 3.9989 8.6981 3.9989C10.3513 3.9989 11.3505 5.18776 11.8937 6.17408C11.9298 6.23953 11.9643 6.30488 11.9973 6.36986C12.0304 6.30488 12.0649 6.23953 12.1009 6.17408C12.6442 5.18776 13.6434 3.9989 15.2965 3.9989C15.9591 3.9989 16.5947 4.26173 17.0635 4.72986C17.5324 5.19803 17.7959 5.83321 17.7959 6.49571C17.7959 6.90965 17.693 7.31293 17.5015 7.67146H19.3286C19.6968 7.67146 19.9953 7.96994 19.9953 8.33813V11.9984C19.9953 12.3666 19.6968 12.6651 19.3286 12.6651H18.5287V19.3313C18.5287 19.6994 18.2302 19.9979 17.862 19.9979H6.13246C5.76427 19.9979 5.46579 19.6994 5.46579 19.3313V12.6651H4.66667C4.29848 12.6651 4 12.3666 4 11.9984V8.33813C4 7.96994 4.29848 7.67146 4.66667 7.67146ZM11.3309 9.00479H5.33333V11.3317H11.3309V9.00479ZM12.6643 11.3317V9.00479H18.662V11.3317H12.6643ZM11.3309 12.6651H6.79913V18.6646H11.3309V12.6651ZM12.6643 18.6646V12.6651H17.1954V18.6646H12.6643ZM15.2965 7.65918H12.889C12.984 7.40045 13.1091 7.10733 13.2688 6.81734C13.7336 5.97352 14.3839 5.33223 15.2965 5.33223C15.6061 5.33223 15.9028 5.45504 16.1214 5.67334C16.34 5.89161 16.4626 6.18744 16.4626 6.49571C16.4626 6.80398 16.34 7.09981 16.1214 7.31808C15.9028 7.53637 15.6061 7.65918 15.2965 7.65918Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
    </i>
  );
}

export default GiftIcon;
